// extracted by mini-css-extract-plugin
export var wordContainer = "_rt-0";